import { get, post, patch, del } from "@/services/axiosUitils";
import {
  BannerResponse,
  GetBannerDetailsByIdResponse,
} from "@/utils/types/Banner/Banner";

const base = "/tenant-core/cms-banners/";

class BannerService {
  getBanners = async (
    page: number,
    pageSize: number,
    enabled: boolean,
    search?: string
  ): Promise<BannerResponse> => {
    const params: Record<string, string | number | boolean> = {
      page,
      page_size: pageSize,
      is_enabled: enabled,
    };
    const q = search?.trim();
    if (q) {
      params.search = q;
    }
    return await get<BannerResponse>(base, { params });
  };

  createBanner = async (banner: FormData): Promise<BannerResponse> => {
    return await post<BannerResponse>(base, banner, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  updateBanner = async (
    id: string,
    banner: FormData
  ): Promise<BannerResponse> => {
    return await patch<BannerResponse>(`${base}${id}/`, banner, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  deleteBanner = async (id: string): Promise<BannerResponse> => {
    return await del<BannerResponse>(`${base}${id}/`);
  };

  updateBannerStatus = async (
    id: string,
    enabled: boolean
  ): Promise<BannerResponse> => {
    return await patch<BannerResponse>(`${base}${id}/`, {
      is_enabled: enabled,
    });
  };

  getBannerDetailsById = async (
    id: string
  ): Promise<GetBannerDetailsByIdResponse> => {
    return await get<GetBannerDetailsByIdResponse>(`${base}${id}/`);
  };
}

export default new BannerService();
